import React from 'react';
import ImageRaw from '../../../../components/image-raw';
import Organizations from './components/organizations';
import ConcertPartnersMobile from '../concert-partners/concert-partners.mobile';
import {OrganizationAndPartnersProps} from './organization-and-partners.type';

const OrganizationAndPartnersMobile: React.FC<OrganizationAndPartnersProps> = ({partners}) => {
    if (!partners) {
        return <></>;
    }

    return (
        <div className="relative w-full h-full mt-[51px]">
            {/* 10 seasons logo */}
            <div className="absolute top-[2%] -translate-y-[50%] left-[10%] w-[124px] h-[122px] z-20">
                <ImageRaw
                    src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/10-seasons-logo-v3.png"
                    alt="Logo 10 seasons"
                    className="object-contain"
                />
            </div>
            <div
                className="relative w-full h-full flex justify-center items-center max-w-[2000px]"
                style={
                    {
                        //backgroundImage: 'url(/assets/images/organization-and-partners-bg-mobile.png)',
                    }
                }>
                <div className="absolute top-0 w-full z-0 ">
                    <ImageRaw
                        src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/organizations/organization-and-partners-bg-mobile.png.png"
                        alt="organization-and-partners-bg-mobile"
                        className="h-full w-full"
                    />
                </div>
                
                <div className="w-full h-full lg:!pt-[50px] !pt-[80px] mx-auto flex flex-col justify-start items-center gap-[22px] z-10">
                    <Organizations />
                    <div className='bg-[#3B1CD9] py-[30px] w-full px-2'>
                        <ConcertPartnersMobile partners={partners} containerClassName="py-[8px] px-[6px]" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrganizationAndPartnersMobile;
